import { Box, Button, makeStyles, withStyles } from "@material-ui/core";
import linksLogoImg from "./images/linkslogo.png";

const useStyles = makeStyles(theme => ({
  base: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'linear-gradient(rgba(103,93,139,0.65), #fff)',
    fontFamily: "auto",
  },
  login: {
    padding: '60px',
    position: 'relative',
  },
  linksTitle: {
    marginBottom: 30,
  },
  linksLogo: {
    width: '60px',
    verticalAlign: 'text-top',
    marginRight: '11px',
  },
  linksStr: {
    color: '#5041c6',
    fontFamily: '"Exo",sans-serif',
    fontSize: '50px',
    fontWeight: 500,
  },
  versionBox: {
    position: 'absolute',
    right: '10px',
    bottom: '10px',
    textAlign: 'center',
    marginTop: 15,
    color: '#5041c6',
    fontFamily: '"Exo",sans-serif',
  },
}));

export const LinksButton = withStyles(() => ({
  root: {
    color: "#FFF3E5",
    backgroundColor: "#02429C",
    '&:hover': {
      backgroundColor: "#012E6D"
    }
  }
}))(Button);

function LinksTitle({children}) {
  const classes = useStyles();
  return (
    <div className={classes.base}>
      <div className={classes.login}>
        <div className={classes.linksTitle}>
          <div className={classes.linksStr}><img src={linksLogoImg} alt="Foster-Links" className={classes.linksLogo}/>FOSTER-Links</div>
        </div>
        {children ? children : null}
        <Box className={classes.versionBox}>{`ver.${process.env.REACT_APP_VERSION}`}</Box>
      </div>
    </div>
  );
}

export default LinksTitle;
